var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFloppyNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6727 3.17275L10.8273 0.32725C10.6173 0.11725 10.332 0 10.0345 0H0.56C0.25025 0 0 0.25025 0 0.56V13.44C0 13.7498 0.25025 14 0.56 14H13.44C13.7498 14 14 13.7498 14 13.44V3.96375C14 3.66625 13.8827 3.38275 13.6727 3.17275ZM4.76 1.12H9.24V3.08H4.76V1.12ZM7 10.815C5.60875 10.815 4.48 9.68625 4.48 8.295C4.48 6.90375 5.60875 5.775 7 5.775C8.39125 5.775 9.52 6.90375 9.52 8.295C9.52 9.68625 8.39125 10.815 7 10.815ZM7 6.895C6.2265 6.895 5.6 7.5215 5.6 8.295C5.6 9.0685 6.2265 9.695 7 9.695C7.7735 9.695 8.4 9.0685 8.4 8.295C8.4 7.5215 7.7735 6.895 7 6.895Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloppyNew);
export default __webpack_public_path__ + "static/media/floppy-new.3895c64575a4f67f526249624fa1daec.svg";
export { ForwardRef as ReactComponent };